const Component = () => import('./BuyItAgain');

// eslint-disable-next-line import/prefer-default-export
export { Component };
